import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { txt } from 'libs/i18n';
import ResultContent from './ResultContent';
import styles from './style.module.less';
const Result = ({ aiResult, willCreateProject, willStreamToProject, isMultipleProjects, }) => {
    return (_jsxs(_Fragment, { children: [_jsx("h4", { children: txt('generatedResult') }), _jsx("div", { className: styles.resultContent, children: _jsx(ResultContent, { aiResult: aiResult, willCreateProject: willCreateProject, willStreamToProject: willStreamToProject, isMultipleProjects: isMultipleProjects }) })] }));
};
export default Result;
